module.exports = __webpack_public_path__ + "static/media/storage-contract-t1.02e9ac74.nom";